import { Check, Circle } from 'lucide-react'
import type { ChecklistItem } from '../types'

interface ConfiguringChecklistProps {
  productLabel: string
  items: ChecklistItem[]
  enabled: Record<string, boolean>
  onToggle: (id: string) => void
  customerName: string | null
}

export function ConfiguringChecklist({ productLabel, items, enabled, onToggle, customerName }: ConfiguringChecklistProps) {
  return (
    <div className="rounded-[12px] p-3" style={{ background: '#ffffff', border: '1px solid #e5e7eb' }}>
      <p className="text-[10px] font-semibold uppercase tracking-wider text-[#64748b] mb-2">
        {productLabel}{customerName ? ` for ${customerName}` : ''} — what&apos;s in scope
      </p>
      <div className="flex flex-wrap gap-1.5">
        {items.map((item) => {
          const active = enabled[item.id] ?? true
          return (
            <button
              key={item.id}
              onClick={() => onToggle(item.id)}
              className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-medium transition-all"
              style={active
                ? { background: '#dcfce7', border: '1px solid #86efac', color: '#15803d' }
                : { background: '#f1f5f9', border: '1px solid #e5e7eb', color: '#64748b' }
              }
            >
              {active ? <Check size={10} /> : <Circle size={10} />}
              {item.label}
            </button>
          )
        })}
      </div>
      <p className="text-[9px] text-[#64748b] mt-2">Click an item to mark it out of scope for this demo.</p>
    </div>
  )
}
